"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.binderConfigs = void 0;
exports.binderConfigs = [
    {
        id: "argo",
        name: "Argo",
        effectiveDate: {
            from: "",
            to: "2022-10-31"
        },
        usClassification: "Surplus Lines",
        uniqueMarketReference: "B0611CV220770",
        commissions: [
            {
                type: "loadsure",
                name: "Loadsure",
                percentage: 25.75
            },
            {
                type: "insuranceBroker",
                name: "Lochain Patrick",
                percentage: 2.5
            }
        ],
        participartingInsurers: [
            {
                name: "Argo Managing Agency Limited trading as Syndicate 1200 at Lloyd's (Argo)",
                percentage: 100
            }
        ],
        productTermsAndConditionsFile: {
            ARDOM: "argo.202206.ARDOM.TnC.pdf",
            ARDOMMEX: "argo.202108.ARINTMEX-REL.TnC.pdf",
            ARDOMLTL: "argo.202206.ARDOMLTL.TnC.pdf",
            ARDOMR: "argo.202206.ARDOMR.TnC.pdf",
            ARDOMRP: "argo.202206.ARDOMRP.TnC.pdf",
            ARINT: "argo.202206.ARINT.TnC.pdf",
            ARINTMEX: "argo.202108.ARINTMEX-REL.TnC.pdf"
        }
    },
    {
        id: "tokiomarine",
        name: "Tokio Marine",
        usClassification: "Surplus Lines",
        effectiveDate: {
            from: "2022-11-01",
            to: "2023-10-31"
        },
        commissions: [
            {
                type: "loadsure",
                name: "Loadsure",
                percentage: 30
            },
            {
                type: "insuranceBroker",
                name: "Lochain Patrick",
                percentage: 2.5
            }
        ],
        uniqueMarketReference: "B0611CV220857",
        participartingInsurers: [
            {
                name: "Tokio Marine Kiln - Lloyd's Underwriter Syndicates 510/KLN (80%) & 1880/TMK (20%) - Lloyd's One Lime Street, London EC3M 7HA, UK",
                percentage: 60
            },
            {
                name: "Convex Insurance UK Limited - LIRMA - 52 Lime Street, London, EC3M 7AF United Kingdom",
                percentage: 15
            },
            {
                name: "Antares - Lloyd's Underwriter Syndicate 1274/AUL - Lloyd's",
                percentage: 15
            },
            {
                name: "Axis - Lloyd's Underwriter Syndicate No. 1686/AXS - Lloyd's",
                percentage: 5
            },
            {
                name: "Aegis - Lloyd's Underwriter Syndicate No. 1225/AES - Lloyd's",
                percentage: 5
            }
        ],
        productTermsAndConditionsFile: {
            ARDOM: "tokio-marine.202207.ARDOM.TnC.pdf",
            ARDOMMEX: "tokio-marine.202207.ARINTMEX.TnC.pdf",
            ARDOMLTL: "tokio-marine.202207.ARDOMLTL.TnC.pdf",
            ARDOMR: "tokio-marine.202207.ARDOMR.TnC.pdf",
            ARDOMRP: "tokio-marine.202207.ARDOMRP.TnC.pdf",
            ARINT: "tokio-marine.202207.ARINT.TnC.pdf",
            ARINTMEX: "tokio-marine.202207.ARINTMEX.TnC.pdf"
        }
    },
    {
        id: "tokiomarine_can",
        name: "Tokio Marine",
        effectiveDate: {
            from: "2022-11-01",
            to: "2023-10-31"
        },
        usClassification: "Surplus Lines",
        commissions: [
            {
                type: "loadsure",
                name: "Loadsure",
                percentage: 30
            },
            {
                type: "insuranceBroker",
                name: "Lochain Patrick",
                percentage: 2.5
            }
        ],
        uniqueMarketReference: "B0611CV220857",
        participartingInsurers: [
            {
                name: "Tokio Marine Kiln - Lloyd's Underwriter Syndicates 510/KLN (80%) & 1880/TMK (20%) - Lloyd's One Lime Street, London EC3M 7HA, UK",
                percentage: 75
            },
            {
                name: "Antares - Lloyd's Underwriter Syndicate 1274/AUL - Lloyd's",
                percentage: 15
            },
            {
                name: "Axis - Lloyd's Underwriter Syndicate No. 1686/AXS - Lloyd's",
                percentage: 5
            },
            {
                name: "Aegis - Lloyd's Underwriter Syndicate No. 1225/AES - Lloyd's",
                percentage: 5
            }
        ],
        productTermsAndConditionsFile: {
            ARDOM: "tokio-marine.202207.ARDOM.TnC.pdf",
            ARDOMMEX: "tokio-marine.202207.ARINTMEX.TnC.pdf",
            ARDOMLTL: "tokio-marine.202207.ARDOMLTL.TnC.pdf",
            ARDOMR: "tokio-marine.202207.ARDOMR.TnC.pdf",
            ARDOMRP: "tokio-marine.202207.ARDOMRP.TnC.pdf",
            ARINT: "tokio-marine.202207.ARINT.TnC.pdf",
            ARINTMEX: "tokio-marine.202207.ARINTMEX.TnC.pdf"
        }
    },
    {
        id: "tokiomarine2023",
        name: "Tokio Marine",
        usClassification: "Surplus Lines",
        effectiveDate: {
            from: "2023-11-01",
            to: "2024-05-24"
        },
        commissions: [
            {
                type: "loadsure",
                name: "Loadsure",
                percentage: 30
            },
            {
                type: "insuranceBroker",
                name: "Lochain Patrick",
                percentage: 2.5
            }
        ],
        uniqueMarketReference: "B0611CV230857",
        participartingInsurers: [
            {
                name: "Tokio Marine Kiln - Lloyd's Underwriter Syndicates 510/KLN (80%) & 1880/TMK (20%) - Lloyd's One Lime Street, London EC3M 7HA, UK",
                percentage: 60
            },
            {
                name: "Convex Insurance UK Limited - LIRMA - 52 Lime Street, London, EC3M 7AF United Kingdom",
                percentage: 15
            },
            {
                name: "Antares - Lloyd's Underwriter Syndicate 1274/AUL - Lloyd's",
                percentage: 15
            },
            {
                name: "Axis - Lloyd's Underwriter Syndicate No. 1686/AXS - Lloyd's",
                percentage: 5
            },
            {
                name: "Aegis - Lloyd's Underwriter Syndicate No. 1225/AES - Lloyd's",
                percentage: 5
            }
        ],
        productTermsAndConditionsFile: {
            ARDOM: "All Risk Domestic General Merchandise- Terms and Conditions.pdf",
            ARDOMMEX: "All Risk International General Merchandise- Mexico Endorsement- Terms and Conditions.pdf",
            ARDOMLTL: "All Risk Domestic LTL General Merchandise- Terms and Conditions.pdf",
            ARDOMR: "All Risk Domestic Refrigerated- Terms and Conditions.pdf",
            ARDOMRP: "All Risk Domestic Refrigerated Plus- Terms and Conditions.pdf",
            ARINT: "All Risk International General Merchandise- Terms and Conditions.pdf",
            ARINTMEX: "All Risk International General Merchandise- Mexico Endorsement- Terms and Conditions.pdf"
        }
    },
    {
        id: "tokiomarine_can2023",
        name: "Tokio Marine",
        effectiveDate: {
            from: "2023-11-01",
            to: "2024-11-11"
        },
        usClassification: "Surplus Lines",
        commissions: [
            {
                type: "loadsure",
                name: "Loadsure",
                percentage: 30
            },
            {
                type: "insuranceBroker",
                name: "Lochain Patrick",
                percentage: 2.5
            }
        ],
        uniqueMarketReference: "B0611CV230857",
        participartingInsurers: [
            {
                name: "Tokio Marine Kiln - Lloyd's Underwriter Syndicates 510/KLN (80%) & 1880/TMK (20%) - Lloyd's One Lime Street, London EC3M 7HA, UK",
                percentage: 75
            },
            {
                name: "Antares - Lloyd's Underwriter Syndicate 1274/AUL - Lloyd's",
                percentage: 15
            },
            {
                name: "Axis - Lloyd's Underwriter Syndicate No. 1686/AXS - Lloyd's",
                percentage: 5
            },
            {
                name: "Aegis - Lloyd's Underwriter Syndicate No. 1225/AES - Lloyd's",
                percentage: 5
            }
        ],
        productTermsAndConditionsFile: {
            ARDOM: "All Risk Domestic General Merchandise- Terms and Conditions.pdf",
            ARDOMMEX: "All Risk International General Merchandise- Mexico Endorsement- Terms and Conditions.pdf",
            ARDOMLTL: "All Risk Domestic LTL General Merchandise- Terms and Conditions.pdf",
            ARDOMR: "All Risk Domestic Refrigerated- Terms and Conditions.pdf",
            ARDOMRP: "All Risk Domestic Refrigerated Plus- Terms and Conditions.pdf",
            ARINT: "All Risk International General Merchandise- Terms and Conditions.pdf",
            ARINTMEX: "All Risk International General Merchandise- Mexico Endorsement- Terms and Conditions.pdf"
        }
    },
    {
        id: "tokiomarine2024",
        name: "Tokio Marine",
        usClassification: "N/A",
        effectiveDate: {
            from: "2024-04-25",
            to: "2024-11-11"
        },
        commissions: [
            {
                type: "loadsure",
                name: "Loadsure",
                percentage: 30
            },
            {
                type: "insuranceBroker",
                name: "Arthur J. Gallagher London",
                percentage: 2.5
            }
        ],
        uniqueMarketReference: "B0611CV230857",
        participartingInsurers: [
            {
                name: "Tokio Marine Kiln - Lloyd's Underwriter Syndicates 510/KLN (80%) & 1880/TMK (20%) - Lloyd's One Lime Street, London EC3M 7HA, UK",
                percentage: 60
            },
            {
                name: "Convex Insurance UK Limited - LIRMA - 52 Lime Street, London, EC3M 7AF United Kingdom",
                percentage: 15
            },
            {
                name: "Antares - Lloyd's Underwriter Syndicate 1274/AUL - Lloyd's",
                percentage: 15
            },
            {
                name: "Axis - Lloyd's Underwriter Syndicate No. 1686/AXS - Lloyd's",
                percentage: 5
            },
            {
                name: "Aegis - Lloyd's Underwriter Syndicate No. 1225/AES - Lloyd's",
                percentage: 5
            }
        ]
    },
    {
        id: "tokiomarine_europe",
        name: "Tokio Marine Europe",
        usClassification: "N/A",
        effectiveDate: {
            from: "2024-04-25",
            to: "2025-03-31"
        },
        commissions: [
            {
                type: "loadsure",
                name: "Loadsure",
                percentage: 30
            },
            {
                type: "insuranceBroker",
                name: "Arthur J. Gallagher Nordic AB",
                percentage: 2.5
            }
        ],
        uniqueMarketReference: "B173424LOA0003",
        participartingInsurers: [
            {
                name: " Tokio Marine Kiln - Lloyd’s Insurance Company S.A. (KLN 5307 / TMK 5332)",
                percentage: 60
            },
            {
                name: "Antares – Lloyd’s Insurance Company S.A. (AUL 5323)",
                percentage: 15
            },
            {
                name: "Convex Europe SA – XIS/C8802",
                percentage: 15
            },
            {
                name: "Axis – Lloyd’s Insurance Company S.A. (AXS 5328)",
                percentage: 5
            },
            {
                name: "Aegis – Lloyd’s Insurance Company S.A. (AES 5322)",
                percentage: 5
            }
        ]
    },
    {
        id: "tokiomarine_europe_2025",
        name: "Tokio Marine Europe",
        usClassification: "N/A",
        effectiveDate: {
            from: "2025-04-01",
            to: "2026-03-31"
        },
        commissions: [
            {
                type: "loadsure",
                name: "Loadsure",
                percentage: 30
            },
            {
                type: "insuranceBroker",
                name: "Arthur J. Gallagher Nordic AB",
                percentage: 2.5
            }
        ],
        uniqueMarketReference: "B173425LOA0003",
        participartingInsurers: [
            {
                name: " Tokio Marine Kiln - Lloyd’s Insurance Company S.A. (KLN 5307 / TMK 5332)",
                percentage: 60
            },
            {
                name: "Antares – Lloyd’s Insurance Company S.A. (AUL 5323)",
                percentage: 15
            },
            {
                name: "Convex Europe SA – XIS/C8802",
                percentage: 15
            },
            {
                name: "Axis – Lloyd’s Insurance Company S.A. (AXS 5328)",
                percentage: 5
            },
            {
                name: "Aegis – Lloyd’s Insurance Company S.A. (AES 5322)",
                percentage: 5
            }
        ]
    },
    {
        id: "tokiomarine2024_2",
        name: "Tokio Marine",
        usClassification: "N/A",
        effectiveDate: {
            from: "2024-11-12",
            to: ""
        },
        commissions: [
            {
                type: "loadsure",
                name: "Loadsure",
                percentage: 30
            },
            {
                type: "insuranceBroker",
                name: "Arthur J. Gallagher London",
                percentage: 2.5
            }
        ],
        uniqueMarketReference: "B133824LOA0001",
        participartingInsurers: [
            {
                name: "Tokio Marine Kiln - Lloyd's Underwriter Syndicates 510/KLN (80%) & 1880/TMK (20%) - Lloyd's One Lime Street, London EC3M 7HA, UK",
                percentage: 60
            },
            {
                name: "Antares - Lloyd's Underwriter Syndicate 1274/AUL - Lloyd's",
                percentage: 15
            },
            {
                name: "Convex Insurance UK Limited - LIRMA - 52 Lime Street, London, EC3M 7AF United Kingdom",
                percentage: 10
            },
            {
                name: "Axis - Lloyd's Underwriter Syndicate No. 1686/AXS - Lloyd's",
                percentage: 10
            },
            {
                name: "Aegis - Lloyd's Underwriter Syndicate No. 1225/AES - Lloyd's",
                percentage: 5
            }
        ]
    },
    {
        id: "tokiomarine_can2024",
        name: "Tokio Marine",
        effectiveDate: {
            from: "2024-11-12",
            to: ""
        },
        usClassification: "Surplus Lines",
        commissions: [
            {
                type: "loadsure",
                name: "Loadsure",
                percentage: 30
            },
            {
                type: "insuranceBroker",
                name: "Lochain Patrick",
                percentage: 2.5
            }
        ],
        uniqueMarketReference: "B133824LOA0001",
        participartingInsurers: [
            {
                name: "Tokio Marine Kiln - Lloyd's Underwriter Syndicates 510/KLN (80%) & 1880/TMK (20%) - Lloyd's One Lime Street, London EC3M 7HA, UK",
                percentage: 70
            },
            {
                name: "Antares - Lloyd's Underwriter Syndicate 1274/AUL - Lloyd's",
                percentage: 15
            },
            {
                name: "Axis - Lloyd's Underwriter Syndicate No. 1686/AXS - Lloyd's",
                percentage: 10
            },
            {
                name: "Aegis - Lloyd's Underwriter Syndicate No. 1225/AES - Lloyd's",
                percentage: 5
            }
        ],
        productTermsAndConditionsFile: {
            ARDOM: "All Risk Domestic General Merchandise- Terms and Conditions.pdf",
            ARDOMMEX: "All Risk International General Merchandise- Mexico Endorsement- Terms and Conditions.pdf",
            ARDOMLTL: "All Risk Domestic LTL General Merchandise- Terms and Conditions.pdf",
            ARDOMR: "All Risk Domestic Refrigerated- Terms and Conditions.pdf",
            ARDOMRP: "All Risk Domestic Refrigerated Plus- Terms and Conditions.pdf",
            ARINT: "All Risk International General Merchandise- Terms and Conditions.pdf",
            ARINTMEX: "All Risk International General Merchandise- Mexico Endorsement- Terms and Conditions.pdf"
        }
    }
];
//# sourceMappingURL=config.js.map